import React, { lazy, Suspense, useEffect, useState, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import Home from "./Components/Home";
import Header from "./Components/Header/Header";
import LazyRender from "./Components/LazyRender";
import Shop from "./Components/Shop/Shop";
import Products from "./Components/Products/Products";
import CartPage from "./Components/Cart/CartPage";
import { CartProvider } from "./Components/Cart/CartContext";
import ImmortalSection from "./Components/ImmortalSection/ImmortalSection";
import { UserProvider } from "./context/UserContext";
import { ModalProvider } from "./ModalContext";
import { useModal } from "./ModalContext";
import ProtectedCheckout from "./ProtectedCheckout"
import { IoIosNotifications } from "react-icons/io";

const ContactUs = lazy(() => import("./Components/Contact/ContactUs"));
const Footer = lazy(() => import("./Components/Home/Footer"));
const AboutUs = lazy(() => import("./Components/AboutUsPage/AboutUs"));
const PageTest = lazy(() => import("./Components/Cart/PageTest"));
const CheckOut = lazy(() => import("./Components/CheckOut/CheckOut"));
const Test = lazy(() => import("./Test/Test"));
const Wikipedia = lazy(() => import("./Test/Wikipedia"));
const Dashboard = lazy(() => import("./Dasboard/Dashboard"));
const TermsConditions = lazy(
  () => import("./Components/Terms/TermsConditionsV2"),
);
const PaymentSuccess = lazy(
  () => import("./Components/CheckOut/PaymentSuccessOrder"),
);
const ArtistPage = lazy(() => import("./Components/Shop/ShopByArtist"));
const SearchResults = lazy(() => import("./Components/Shop/SearchResults"));


// Create a wrapper component to use the useLocation hook
function AppContent() {
  const { openModal } = useModal();
  const location = useLocation();
  const isHome = location.pathname === "/";
  const Ip = "http://api.righttracklb.com/";
  const shouldRenderNavbar =
    !location.pathname.includes("/admin") &&
    !location.pathname.includes("/dashboard");

  useEffect(() => {
    const modalShown = localStorage.getItem("termsModalShown");

    if (!modalShown) {
      const timer = setTimeout(() => {
        openModal(
          <IoIosNotifications size={40} color="#993400" />,
          "Login or Register",
          "Create an account or login to unlock special benefits, exclusive offers, and discounts!",
          "Stay updated with our newsletter for new arrivals and promotions.",
          "Easily track your order history and manage your favorites."
        );
        localStorage.setItem("termsModalShown", "true");
      }, 300000);

      return () => clearTimeout(timer);
    }
  }, [openModal]);
  const [hasSeenIntro, setHasSeenIntro] = useState(false);
  return (
    <>
      {shouldRenderNavbar ? (
        <>
          <Header />
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home Ip={Ip} hasSeenIntro={hasSeenIntro} setHasSeenIntro={setHasSeenIntro} />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/aboutus" element={<AboutUs />} />
              {/* <Route path="/PageTest" element={<PageTest />} /> */}
              {/* <Route path="/CheckOut" element={<CheckOut />} /> */}
              <Route
                path="/CheckOut"
                element={
                  <ProtectedCheckout>
                    <CheckOut />
                  </ProtectedCheckout>
                }
              />
              <Route path="/ImmortalSection" element={<ImmortalSection />} />
              <Route path="/products/:id" element={<Products />} />
              <Route path="/cart" element={<CartPage />} />
              {/* <Route path="/Test" element={<Test />} /> */}
              {/* <Route path="/Wikipedia" element={<Wikipedia />} /> */}
              <Route path="/TermsConditions" element={<TermsConditions />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/artist/:artist" element={<ArtistPage />} />

              <Route path="/search" element={<SearchResults />} />
              {/* <Route path="/payment-success" element={<PaymentSuccess />} /> */}
            </Routes>
          </Suspense>
          <Suspense fallback={<div style={{ height: 120 }} />}>
            {!isHome && (
              <LazyRender>
                <Footer />
              </LazyRender>
            )}
          </Suspense>
        </>
      ) : (
        <Routes>
          <Route path="/admin" element={<Dashboard />} />
        </Routes>
      )}
    </>
  );
}
function App() {
  return (
    <Router>
      <UserProvider>
        <ModalProvider>
          <CartProvider>
            <AppContent />
          </CartProvider>
        </ModalProvider>
      </UserProvider>
    </Router>
  );
}

export default App;
